import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import HeaderContainer from '@js/containers/Common/HeaderContainer';
import Breadcrumb from '@js/components/Common/Breadcrumbs';

// redux store
import store from '@js/store';

import 'bootstrap/dist/js/bootstrap.bundle.min';
import '@scss/pages/home.scss';

// 測試首頁
render(
  <Provider store={store}>

    <BrowserRouter>
      <Suspense fallback={<div />}>
        <HeaderContainer />
        <Breadcrumb />
      </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('zh__food__online__header'),
);
